import React from "react";
import styled from "../style.module.css";
import { ACCENTS } from "./theme";

// Centered funnel. `stages` = [{ label, value }] in funnel order.
// Each band's width is relative to the largest stage. Between stages it shows
// the step change vs the previous stage, with a direction that follows the
// data: ↓ when the count falls, ↑ when it rises, → when unchanged. (It used
// to hard-code ↓ with a drop-off %, which read "↓ -50%" for a rising step.)
const stepChange = (prev, cur) => {
  if (!(prev > 0)) return null;
  const pct = Math.round((Math.abs(cur - prev) / prev) * 100);
  if (cur < prev) return { arrow: "↓", pct, title: `${pct}% fewer than the previous stage` };
  if (cur > prev) return { arrow: "↑", pct, title: `${pct}% more than the previous stage` };
  return { arrow: "→", pct: 0, title: "Same as the previous stage" };
};

const FunnelChart = ({ title, stages, formatValue, emptyHint, asOf = true }) => {
  const data = (stages || []).map((s) => ({ ...s, value: Number(s.value) || 0 }));
  const top = data.reduce((m, s) => Math.max(m, s.value), 0);
  const hasData = top > 0;
  const fmt = (v) => (formatValue ? formatValue(v) : Number(v).toLocaleString());

  return (
    <div className={styled.chartCard}>
      <div className={styled.chartCardHead}>
        <h3 className={styled.chartTitle}>{title}</h3>
        {asOf && <span className={styled.asOfTag}>Live</span>}
      </div>
      {hasData ? (
        <div className={styled.funnel}>
          {data.map((s, i) => {
            const widthPct = top > 0 ? Math.max((s.value / top) * 100, 6) : 0;
            const step = i > 0 ? stepChange(data[i - 1].value, s.value) : null;
            return (
              <div key={i} className={styled.funnelStage}>
                {step && (
                  <span className={styled.funnelStep} title={step.title}>
                    {step.arrow} {step.pct}%
                  </span>
                )}
                <div
                  className={styled.funnelBand}
                  style={{ width: `${widthPct}%`, background: ACCENTS[i % ACCENTS.length] }}
                >
                  <span className={styled.funnelValue}>{fmt(s.value)}</span>
                </div>
                <span className={styled.funnelLabel}>{s.label}</span>
              </div>
            );
          })}
        </div>
      ) : (
        <p className={styled.emptyHint}>{emptyHint || "No data yet."}</p>
      )}
    </div>
  );
};

export default FunnelChart;
